/* Local dependencies */
import { Device } from "../types";
import { CreateDeviceActionTypes } from "../create-device/redux/acrions";
import { UpdateDeviceActionTypes } from "../update-device/redux/acrions";
import { VerifyDeviceActionTypes } from "../verify-device/redux/acrions";
import { DeleteDeviceActionTypes } from "../delete-device/redux/acrions";
import { AnyAction } from 'redux';

export interface DeviceState {
  createdDevice: Device | null;
  updatedDevice: Device | null;
  verifiedDevice: Device | null;
  loading: boolean;
  error: Error | null;
}

const initialState: DeviceState = {
  createdDevice: null,
  updatedDevice: null,
  verifiedDevice: null,
  loading: false,
  error: null,
};

export const deviceReducer = (state = initialState, action: AnyAction): DeviceState => {
  switch (action.type) {
    case CreateDeviceActionTypes.CREATE_DEVICE_REQUEST:
      return { ...state, loading: true, error: null };
    case UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST:
      return { ...state, loading: true, error: null };
    case VerifyDeviceActionTypes.VERIFY_DEVICE_REQUEST:
      return { ...state, loading: true, error: null };
    case DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST:
      return { ...state, loading: true, error: null };
    case CreateDeviceActionTypes.CREATE_DEVICE_SUCCESS: {
      const createdDevice = action.payload as Device;
      return { ...state, loading: false, createdDevice, error: null };
    }
    case UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCESS: {
      const updatedDevice = action.payload as Device;
      return { ...state, loading: false, updatedDevice, error: null };
    }
    case VerifyDeviceActionTypes.VERIFY_DEVICE_SUCCESS: {
      const verifiedDevice = action.payload as Device;
      return { ...state, loading: false, verifiedDevice, error: null };
    }
    case DeleteDeviceActionTypes.DELETE_DEVICE_SUCCESS: {
      return { ...state, loading: false, verifiedDevice: null, error: null };
    }
    case CreateDeviceActionTypes.CREATE_DEVICE_FAILURE:
      return { ...state, loading: false, error: action.payload as Error };
    case UpdateDeviceActionTypes.UPDATE_DEVICE_FAILURE:
      return { ...state, loading: false, error: action.payload as Error };
    case VerifyDeviceActionTypes.VERIFY_DEVICE_FAILURE:
      return { ...state, loading: false, error: action.payload as Error };
    case DeleteDeviceActionTypes.DELETE_DEVICE_FAILURE:
      return { ...state, loading: false, error: action.payload as Error };
    default:
      return state;
  }
};

